import Check from '@mui/icons-material/Check';
import { Link } from '@mui/material';

import { links } from '@/localization';

import LargeAlert from '../../LargeAlert';

function Reviewing() {
  return (
    <LargeAlert
      icon={Check}
      title="We're reviewing your account"
      severity="success"
      description={
        <>
          You&apos;ll receive an email as soon as you’re approved.
          <br />
          Questions? Email <Link href={links.basetenSupportEmail}>support@baseten.co.</Link>
        </>
      }
    />
  );
}

export default Reviewing;
